module.exports = __webpack_public_path__ + "img/450306.78f50a73.png";